import { render, staticRenderFns } from "./GameScrapPicture.vue?vue&type=template&id=1eb8a188&scoped=true"
import script from "./GameScrapPicture.vue?vue&type=script&lang=js"
export * from "./GameScrapPicture.vue?vue&type=script&lang=js"
import style0 from "./GameScrapPicture.vue?vue&type=style&index=0&id=1eb8a188&prod&lang=sass&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1eb8a188",
  null
  
)

export default component.exports